import { render, staticRenderFns } from "./category-selector.app.vue?vue&type=template&id=384f3bd8&"
import script from "./category-selector.app.vue?vue&type=script&lang=js&"
export * from "./category-selector.app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports